import React                            from 'react';
import {render, unmountComponentAtNode} from 'react-dom';
import PjaxWrapper                      from '../utils/PjaxWrapper';
import ContestGridWrapper               from "../components/ContestGridWrapper";
import Flux                             from "../flux/Flux";

function run(containerId, contestsGridConfig, unmountOnPjax = true, contestId = '', contestArea = '', startMediaIndex = null, shownTabs = [], contestTitle = '', shareUrl, actorName, guestData) {
	Flux.Contest.init(contestsGridConfig, contestId, contestArea, guestData);

	const container = document.getElementById(containerId);
	if (container) {
		render(<ContestGridWrapper isMobile={false} contestId={contestId} contestArea={contestArea} contestsGridConfig={contestsGridConfig} containerId={containerId} startMediaIndex={startMediaIndex} actorName={actorName} guestData={guestData}/>, container);

		if (unmountOnPjax) {
			PjaxWrapper.addUnloadFunc(() => {
				unmountComponentAtNode(container);
			});
		}

	}
}

export {run};
